import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';


import Home from './components/home/home';
import About from './components/about/about';
import Contact from './components/contact-us/contact-us';
import TopBar from './components/navbar/navbar';
import Games from './components/games/games';
import Categories from './components/games/categoryList';
import Game from './components/play/game';
import Search from './components/search/search';
import BackButton from "./components/backButton/backbutton";
import Footer from "./components/footer/footer"; // Import the Footer component

import AboutBrowserGames from "../src/components/static/AboutBrowserGames";
import BestBrowserGames from "../src/components/static/BestBrowserGames";
import BestMultiplayer from "../src/components/static/BestMultiplayer";
import Educational from "../src/components/static/Educational";
import FreeGames from "../src/components/static/FreeGames";
import HTML5Games from "../src/components/static/HTML5Games";
import NoDownload from "../src/components/static/NoDownload";
import TopHypercasual from "../src/components/static/TopHypercasual";
import Whyonline from "../src/components/static/whyonline";

const helmetContext = {};

function App() {
  const [mainLoaded, setMainLoaded] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMainLoaded(true);
    }, 150); // tweak as needed (50-150ms is often enough)

    return () => clearTimeout(timeout);
  }, []);

  return (
    <HelmetProvider context={helmetContext}>
      <Router>
        <Helmet>
          <title>Play Browser Games | Free Online Games</title>
          <meta name="description" content="Play the best browser games and explore various online game categories." />
          <meta name="keywords" content="browser games, games, online games, free games" />
        </Helmet>

        <div className="flex flex-col min-h-screen bg-[#0d0d1a] text-[#00F0FF]">
          <TopBar />
          <BackButton />

          {/* This main block pushes footer to bottom */}
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/games/:category" element={<Games />} />
              <Route path="/game/:gameId" element={<Game />} />
              <Route path="/search" element={<Search />} />
              <Route path="/categories" element={<Categories />} />

              <Route path="/about-browser-games" element={<AboutBrowserGames />} />
              <Route path="/best-browser-games" element={<BestBrowserGames />} />
              <Route path="/free-games" element={<FreeGames />} />
              <Route path="/html5-games" element={<HTML5Games />} />
              <Route path="/best-multiplayer" element={<BestMultiplayer />} />
              <Route path="/educations" element={<Educational />} />
              <Route path="/no-download" element={<NoDownload />} />
              <Route path="/top-hypercasuals" element={<TopHypercasual />} />
              <Route path="/why-online" element={<Whyonline />} />

            </Routes>
          </main>

          {mainLoaded && <Footer />}
        </div>
      </Router>
    </HelmetProvider>
  );
}
export default App;
